import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ITeklifHareketleriStoklar_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITeklifHareketleriStoklar_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetTeklifRevizeSiraStoklari: any[];
  GetTeklifRevizeSiraStoklari_dummy: any[];
}

export class TeklifHareketleriStoklar_ScreenBase extends React.PureComponent<
  ITeklifHareketleriStoklar_ScreenProps,
  any
> {
  teklifhareketleristoklar_58290_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 237532,
          PropertyName: "value",
          Value: "Numbered Offer",
          TagName: "Label9_value",
        },
        {
          Id: 86451,
          PropertyName: "value",
          Value: "Serial Number :",
          TagName: "Label10_value",
        },
        {
          Id: 824789,
          PropertyName: "title",
          Value: "History",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 252170,
          PropertyName: "title",
          Value: "Stock Code",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 43329,
          PropertyName: "title",
          Value: "Stock Name",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 74004,
          PropertyName: "title",
          Value: "Amount",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 19304,
          PropertyName: "title",
          Value: "Unit Price",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 49331,
          PropertyName: "title",
          Value: "Customer Brand",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 647018,
          PropertyName: "title",
          Value: "The Plazier",
          TagName: "TableTemplateColumn8_title",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [],
    },
    {
      Id: "2eda4036-7d2c-43e8-8170-fd83b24c1802",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 286633,
          PropertyName: "value",
          Value: "Numaralı Teklif Stoklarını Görebilirsiniz",
        },
        { Id: 86451, PropertyName: "value", Value: "Sıra No :" },
        { Id: 824789, PropertyName: "title", Value: "Tarih" },
        { Id: 395572, PropertyName: "value", Value: "[datafield:tarih]" },
        { Id: 252170, PropertyName: "title", Value: "Stok Kodu" },
        { Id: 491050, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 43329, PropertyName: "title", Value: "Stok Adı" },
        { Id: 422872, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 74004, PropertyName: "title", Value: "Miktar" },
        { Id: 812239, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 19304, PropertyName: "title", Value: "Birim Fiyat" },
        { Id: 394982, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 49331, PropertyName: "title", Value: "Müşteri Marka" },
        { Id: 44355, PropertyName: "value", Value: "[datafield:musterimarka]" },
        { Id: 647018, PropertyName: "title", Value: "Plasiyer" },
        { Id: 883403, PropertyName: "value", Value: "[datafield:plasiyer]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.teklifhareketleristoklar_58290_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetTeklifRevizeSiraStoklari: [],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("teklifhareketleristoklar", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.TeklifHareketleriStoklarPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("teklifhareketleristoklar", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("teklifhareketleristoklar", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TeklifHareketleriStoklarPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  TeklifHareketleriStoklarPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      SiraNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.siraNo ?? this.props.screenInputs.sirano,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifHareketleriStoklar/TeklifHareketleriStoklarPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetTeklifRevizeSiraStoklari =
      result?.data.getTeklifRevizeSiraStoklari;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifHareketleriStoklarPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifHareketleriStoklarPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_58290 =
      stateVars.GetTeklifRevizeSiraStoklari ??
      this.state.GetTeklifRevizeSiraStoklari;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TeklifHareketleriStoklarPageInit();
    }
  }
}
